import { Component, Input } from '@angular/core';
import { PolicyDetailsResponse, PolicyOption, NotificationIntimation } from '../../../../interfaces/policy-details.interface';

@Component({
  selector: 'app-view-policy-details',
  templateUrl: './view-policy-details.component.html',
  styleUrl: './view-policy-details.component.css'
})
export class ViewPolicyDetailsComponent {
  @Input() policyDetails: PolicyDetailsResponse | null = null;
  @Input() loading: boolean = false;

  isVMPolicy(): boolean {
    return this.policyDetails?.ResourceType?.toLowerCase() === 'vm';
  }

  isSubscriptionPolicy(): boolean {
    return this.policyDetails?.ResourceType?.toLowerCase() === 'subscription';
  }

  hasCreateOptions(): boolean {
    return !!(this.policyDetails?.CreateOptions && this.getActiveOptions(this.policyDetails.CreateOptions).length > 0);
  }

  hasCreationPolicyOptions(): boolean {
    return !!(this.policyDetails?.CreationPolicyOptions && this.getActiveOptions(this.policyDetails.CreationPolicyOptions).length > 0);
  }

  hasDailyDeletionOptions(): boolean {
    return !!(this.policyDetails?.DailyDeletionPolicyOptions && this.getActiveOptions(this.policyDetails.DailyDeletionPolicyOptions).length > 0);
  }

  hasClassEndDeletionOptions(): boolean {
    return !!(this.policyDetails?.ClassEndDeletionOptions && this.getActiveOptions(this.policyDetails.ClassEndDeletionOptions).length > 0);
  }

  hasQuotaReachedOptions(): boolean {
    return !!(this.policyDetails?.QuotaReached && this.getActiveOptions(this.policyDetails.QuotaReached).length > 0);
  }

  hasNotificationIntimations(): boolean {
    return !!(this.policyDetails?.NotificationIntimations && this.policyDetails.NotificationIntimations.length > 0);
  }

  getActiveOptions(options: PolicyOption[]): PolicyOption[] {
    return options.filter(option => option.optionValue === 'true');
  }

  getInactiveOptions(options: PolicyOption[]): PolicyOption[] {
    return options.filter(option => option.optionValue === 'false');
  }

  processDescription(description: string, parVal?: string, parUnit?: string): string {
    if (parVal && parUnit) {
      return description.replace(/#parVal/g, parVal).replace(/#parUnit/g, parUnit);
    }
    return description;
  }

  getResourceTypeIcon(): string {
    if (this.isVMPolicy()) {
      return 'fas fa-server';
    } else if (this.isSubscriptionPolicy()) {
      return 'fas fa-credit-card';
    }
    return 'fas fa-cog';
  }

  getResourceTypeBadgeClass(): string {
    if (this.isVMPolicy()) {
      return 'badge-vm';
    } else if (this.isSubscriptionPolicy()) {
      return 'badge-subscription';
    }
    return 'badge-default';
  }

  getAllTeamTypes(): string[] {
    if (!this.policyDetails?.NotificationIntimations) {
      return [];
    }
    
    const teamTypes = new Set<string>();
    this.policyDetails.NotificationIntimations.forEach(notification => {
      notification.teams.forEach(team => {
        teamTypes.add(team.name);
      });
    });
    
    return Array.from(teamTypes).sort();
  }

  hasTeamType(notification: NotificationIntimation, teamType: string): boolean {
    return notification.teams.some(team => team.name === teamType);
  }
}
